import { useContext, useRef, useCallback } from 'react';
import { WizardContext, StepContextProps, WizardContextProps } from '../contexts';

const useStep = (): StepContextProps => {
  const context = useContext(WizardContext) as WizardContextProps;
  const onPrev = useRef(() => null);
  const onNext = useRef(() => null);

  const handlePrev = useCallback(
    (ev) => {
      if (ev) {
        ev.preventDefault();
      }

      onPrev.current();
      context.goPrev();
    },
    [onPrev, context],
  );

  const handleNext = useCallback(
    (ev) => {
      if (ev) {
        ev.preventDefault();
      }

      onNext.current();
      context.goNext();
    },
    [onNext, context],
  );

  return {
    onPrev,
    onNext,
    handlePrev,
    handleNext,
  };
};

export { useStep };
